let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6RsmN")).then(() => parcelRequire('341F6'));